<template>
  <div class="row scrollable edit-participant bg-white">
    <loading class="col" name="load participant details">
      <div class="col text-center">
        <h3 class="mt-3">{{$t('pages.admin.EditParticipant')}}</h3>
        <hr/>
        <div class="alert alert-danger" v-if="error">{{$t(error)}}</div>
        <formly-form :fields="fields" :form="form" :model="model" ref="edit"/>
        <div v-if="participant && participant.note">
          <label>{{$t('fields.UserNote')}}</label>
          <span v-html="participant.note"></span>
        </div>
        <div class="text-right mt-3 mb-3">
          <button :class="(disabled ? 'disabled ' : '') + 'btn btn-danger mr-2'" :disabled="disabled"
                  @click="assignAnimator">{{ $t('button.AssignAnimator') }}
          </button>
          <button :class="(disabled ? 'disabled ' : '') + 'btn btn-danger mr-2'" :disabled="disabled" v-if="participant.subscribed"
                  @click="unsubscribe">{{ $t('button.Unsubscribe') }}
          </button>
          <button :class="(disabled ? 'disabled ' : '') + 'btn btn-danger mr-2'" :disabled="disabled" v-if="!participant.subscribed"
                  @click="subscribe">{{ $t('button.Subscribe') }}
          </button>
          <button :class="(disabled ? 'disabled ' : '') + 'btn btn-primary'" :disabled="disabled"
                  @click="submit">{{ $t('button.Save') }}
          </button>
        </div>
      </div>
    </loading>
  </div>
</template>

<script>
    import {mapActions} from 'vuex';
    import find from 'lodash/find';
    import {ROUTER_NAMES} from '../../constants';
    import validation from "../../utils/preDefinedValidation";
    import groups from '../../api/groups';

    export default {
        name: 'EditParticipant',
        data() {


            return {
                form: {},
                disabled: false,
                error: '',
                model: {
                    group: '',
                    paid: '',
                    volunteerTypeId: '',
                    adminNote: ''
                },
                fields: [
                    {
                        key: 'paid',
                        type: 'input',
                        templateOptions: {
                            label: this.$t('fields.Paid'),
                            inputType: 'number',
                            wrapperClasses: 'w-100',
                        },
                        validators: {
                            valid: validation.validNumber
                        }
                    },
                    {
                        key: 'group',
                        type: 'input',
                        templateOptions: {
                            label: this.$t('fields.group'),
                            inputType: 'number',
                            wrapperClasses: 'w-100',
                        },
                        validators: {
                            valid: validation.validNumber
                        }
                    },
                    {
                        key: 'volunteerTypeId',
                        type: 'multi-select',
                        options: [],
                        templateOptions: {
                            label: this.$t('fields.VolunteerTypes'),
                            multiple: false,
                            closeOnSelect: true
                        },
                        required: false,
                    },
                    {
                        key: 'adminNote',
                        type: 'mce',
                        templateOptions: {
                            label: this.$t('fields.Note'),
                            note: this.$t('admin.participantNote')
                        }
                    },
                    {
                        key: 'isLeader',
                        type: 'checkbox',
                        templateOptions: {
                            label: this.$t('fields.isLeader'),
                        }
                    }
                ]
            };
        },
        created() {
            this.$wait.start('load participant details');
            const event = this.detailEvent({
                eventId: this.eventId
            });
            const participantDetail = this.loadParticipantDetail({
                eventId: this.eventId,
                userId: this.userId
            });

            Promise.all([event, participantDetail])
                .then(() => {
                    const volunteerType = find(this.volunteerTypes, {id: this.participant.volunteer_type_id});
                    const volunteerTypes = this.event.volunteerTypes;
                    this.fields[2].options = volunteerTypes ? volunteerTypes.map((type) => {
                        return {
                            label: type.name,
                            value: type.id
                        };
                    }) : [];


                    this.model.paid = this.participant.paid;
                    this.model.group = this.participant.group_name;
                    this.model.adminNote = this.participant.admin_note;
                    this.model.isLeader = this.participant.is_leader == 1;
                    if (volunteerType) {
                        this.model.volunteerTypeId = {
                            value: volunteerType.id,
                            label: volunteerType.name
                        };
                    }

                    this.$wait.end('load participant details');
                });
        },
        computed: {
            eventId() {
                return this.$route.params.eventId;
            },
            event() {
                return this.$store.state.admin.eventDetail[this.eventId];
            },
            userId() {
                return this.$route.params.userId;
            },
            volunteerTypes() {
                return this.$store.state.admin.volunteerTypes;
            },
            participant() {
                return this.$store.state.admin.participantDetail[this.eventId] ? this.$store.state.admin.participantDetail[this.eventId][this.userId] : {};
            }
        },
        methods: {
            ...mapActions(['detailEvent', 'loadParticipantDetail', 'editParticipant', 'unsubscribeParticipant', 'subscribeParticipant']),
            unsubscribe(e) {
                this.disabled = true;
                e.preventDefault();
                this.unsubscribeParticipant({
                    eventId: this.eventId,
                    userId: this.userId,
                }).then(() => {
                    return this.loadParticipantDetail({
                        eventId: this.eventId,
                        userId: this.userId
                    })
                }).then(() => this.disabled = false, () => this.disabled = false);
            },
            subscribe(e) {
                this.disabled = true;
                e.preventDefault();
                this.subscribeParticipant({
                    eventId: this.eventId,
                    userId: this.userId,
                }).then(() => {
                    return this.loadParticipantDetail({
                        eventId: this.eventId,
                        userId: this.userId
                    });
                }).then(() => this.disabled = false, () => this.disabled = false);
            },
            assignAnimator(e) {
                this.disabled = true;
                e.preventDefault(); 

                groups.assignAnimator({
                    eventId: this.eventId,
                    userId: this.userId,
                    groupName: this.participant.group_name
                }).then(() => {
                   this.disabled = false;
                })
            },
            submit(e) {
                e.preventDefault();
                this.$refs.edit.validate()
                    .then(() => {
                        if (!this.form.$valid) return;
                        this.disabled = true;
                        const data = {
                            eventId: this.eventId,
                            userId: this.userId,
                            participantId: this.participant.id,
                            adminNote: this.model.adminNote,
                            paid: this.model.paid,
                            isLeader: this.model.isLeader ? this.model.isLeader : false,
                        };

                        if (this.model.volunteerTypeId) {
                            data['volunteerTypeId'] = this.model.volunteerTypeId.value;
                        }

                        if (this.model.group) {
                            data['group_name'] = this.model.group.toString();
                        }
                        this.editParticipant(data)
                            .then(() => {
                                this.disabled = false;
                                this.$router.back();
                            }, () => {
                                this.disabled = false;
                                this.$router.push({
                                    name: ROUTER_NAMES.ERROR
                                });
                            });
                    });
            }
        }
    };
</script>

<style scoped>

</style>
